import styled, { css } from 'styled-components';

import { STANDARD_EASING, STANDARD_TIME } from 'constants/animations';
import { ChevronDown16 } from 'ui/icons/aurora/16px/ChevronDown16';
import { pxToRem } from 'utils/convert';
import { ARROW_DIRECTION_DOWN, ARROW_DIRECTION_RIGHT } from './constants';

type StyledDivProps = {
  width: number;
  height: number;
  isCollapsed: boolean;
  arrowStart: number;
  arrowEnd: number;
};
const StyledDiv = styled.div<StyledDivProps>`
  ${({ width }) => `width: ${pxToRem(width)};`}
  ${({ height }) => `height: ${pxToRem(height)};`}

  display: inline-block;
  transition: all ${STANDARD_TIME}s ${STANDARD_EASING};
  ${({
    isCollapsed,
    arrowStart,
    arrowEnd,
  }: {
    isCollapsed: boolean;
    arrowStart: number;
    arrowEnd: number;
  }) =>
    isCollapsed
      ? css`
          transform: rotate(${arrowStart}deg);
        `
      : css`
          transform: rotate(${arrowEnd}deg);
        `};
`;

export type CollapsibleContentArrowProps = {
  /** Required boolean determines if the content is open or closed */
  isCollapsed: boolean;
  /** Width of arrow */
  width?: number;
  /** Height of arrow */
  height?: number;
  /** Arrow starting orientation  */
  arrowStart?: number;
  /** Arrow ending orientation */
  arrowEnd?: number;
};

export const CollapsibleContentArrow = ({
  isCollapsed,
  width = 24,
  height = 24,
  arrowStart = ARROW_DIRECTION_RIGHT,
  arrowEnd = ARROW_DIRECTION_DOWN,
  ...props
}: CollapsibleContentArrowProps) => {
  return (
    <StyledDiv
      isCollapsed={isCollapsed}
      width={width}
      height={height}
      arrowStart={arrowStart}
      arrowEnd={arrowEnd}
      data-test="collapsible-content-arrow"
      data-iscollapsed={isCollapsed}
      {...props}
    >
      <ChevronDown16 />
    </StyledDiv>
  );
};
